import { useGetIdentity } from "@refinedev/core";
import { UserRole } from "../models/role";

export const useAdmin = () => {
    const { data: user } = useGetIdentity();
    const roleId = user?.role?.id;
    const isAdmin = roleId === UserRole.admin || roleId === String(UserRole.admin) || Number(roleId) === UserRole.admin;
    //console.log("useAdmin - roleId:", roleId, "UserRole.admin:", UserRole.admin, "isAdmin:", isAdmin);
    return isAdmin;
}

export const useSuperAdmin = () => {
    const { data: user } = useGetIdentity();
    const roleId = user?.role?.id;
    const isSuperAdmin = roleId === UserRole.superAdmin || roleId === String(UserRole.superAdmin) || Number(roleId) === UserRole.superAdmin;
    //console.log("useSuperAdmin - roleId:", roleId, "UserRole.superAdmin:", UserRole.superAdmin, "isSuperAdmin:", isSuperAdmin);
    return isSuperAdmin;
}

export const useTuner = () => {
    const { data: user } = useGetIdentity();
    const roleId = user?.role?.id;
    const isTuner = roleId === UserRole.tuner || roleId === String(UserRole.tuner) || Number(roleId) === UserRole.tuner;
    //console.log("useTuner - roleId:", roleId, "UserRole.tuner:", UserRole.tuner, "isTuner:", isTuner);
    return isTuner;
}

export const useCustomer = () => {
    const { data: user } = useGetIdentity();
    const roleId = user?.role?.id;
    const isCustomer = roleId === UserRole.user || roleId === String(UserRole.user) || Number(roleId) === UserRole.user;
    //console.log("useCustomer - roleId:", roleId, "UserRole.user:", UserRole.user, "isCustomer:", isCustomer);
    return isCustomer;
}